<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>
    <div v-else>
        <v-container>
        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12" class="d-flex">
                                <h5 class="mt-1">Mis datos</h5>
                            </v-col>
                        </v-row>
                        <v-row class="mt-3">
                            <v-col cols="12" md="4" class="mt-n3">
                                <v-text-field label="Rut" class='casilla_grey text-body-2' v-model="rut" dense rounded readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8" class="mt-n3">
                                <v-text-field label="Nombre" class='casilla_grey text-body-2' v-model="nombre" dense rounded readonly></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6">
                <v-row>
                    <v-col cols="12" md="12">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                             <v-container>
                                <v-row class="mt-3">
                                    <v-col cols="12" md="12" class="mt-n5 d-flex">
                                        <h5 class="mt-1">Selecciona Producto</h5>
                                        <v-btn @click="d_products=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="1" md="6"></v-col>
                                    <v-col cols="10" md="6" class="mt-n5 text-center">
                                        <!-- <v-text-field label="Cod. Barra" class='casilla_beige text-body-2' v-model="barra" dense rounded></v-text-field> -->
                                        <v-text-field class='casilla_beige text-body-2' id="barr" label="Cod. Barra"
                                            @change="captureBarra(barra)" v-model="barra" dense rounded>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                             </v-container>
                        </v-sheet>
                    </v-col>                                        
                </v-row>
            </v-col>
        </v-row>
        <div>
            <v-container>
                <h5 class="mt-2">Mis Productos</h5>
                <v-divider></v-divider>
                <v-row class="mt-2">
                    <v-col cols="12" md="6" v-for="item in products_lista" :key="item.id" >
                        <v-card rounded="xl" style="background-color: beige;">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="3" class="text-center">
                                        <div v-if="item.img1==''" >
                                            <img style="border-radius: 10px;border-color: lightgrey;" src="@/assets/no_image.jpg" width="100" height="100"/>
                                        </div>
                                        <div v-else>
                                            <img style="border-radius: 10px;border-color: lightgrey;" :src="item.img1" width="100" height="100"/>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="9">
                                        <v-row class="mt-0">
                                            <v-col cols="12" md="8" class="mt-n3">
                                                <v-sheet color="#c1680e" style="border:1px solid lightgray" width="100%" height="35px" rounded="xl">
                                                    <h5 class="mt-2 ml-2 white--text">ORDEN: {{ item.orden }}</h5>
                                                </v-sheet>
                                            </v-col>
                                            <v-col cols="12" md="4" class="mt-n3 text-end">
                                                <h6 class="grey--text">{{ item.fecha }} {{ item.hora }}</h6>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n3">
                                            <v-col cols="12" md="12">
                                                <h5>{{ item.producto }}</h5>
                                                <h6>{{ item.marca }} - {{ item.modelo }} - {{ item.serie }}</h6>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n5">
                                            <v-col cols="12" md="8">                                                
                                                <h6 class="grey--text">Cod.Barra: {{ item.barra }}</h6>
                                            </v-col>
                                            <v-col cols="12" md="4" class="text-end">
                                                <v-btn @click="verify_devolution(item)" rounded color="error" x-small dense>Devolver</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        </v-container>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProducts" dense dark height="400px" fixed-header
                    :search="products_search" :headers="products_titulo" :items="products_lista" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.codigo="{ item }">
                        <v-chip small>
                            {{ item.codigo }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- confirma devolucion -->
        <v-dialog v-model="d_confirma" transition="dialog-bottom-transition" max-width="450" persistent>
            <v-card>
                <v-card-title>
                    Confirma Devolución
                <v-spacer></v-spacer>
                    <v-icon @click="d_confirma=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-sheet class="mt-2" style="border:1px solid lightgray; background-color: lightcyan;" width="100%" rounded="xl">
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <h5>{{ producto_dev }}</h5>
                                    <h6>{{ marca_dev }} - {{ modelo_dev }} - {{ serie_dev }}</h6>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-sheet>
                    <v-row class="ml-1 mt-3">
                        <v-col cols="12" md="12" class="mt-n3">
                            <h5>Fecha y Hora de devolución aproximada</h5>
                        </v-col>
                        <v-col cols="12" md="6" class="mt-n5 d-flex">
                            <v-icon class="mt-0">event</v-icon>
                            <v-text-field class='casilla_grey text-body-2' v-model="fecha" readonly dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class=" mt-n5 d-flex">
                            <v-icon class="mt-0">timer</v-icon>
                            <v-text-field class='casilla_grey text-body-2' v-model="hora" readonly dense rounded></v-text-field>
                            <h1 class="ml-1 mr-1 mt-1">:</h1>                                        
                            <v-text-field class='casilla_grey text-body-2' v-model="minuto" readonly dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-n2">
                            <v-btn @click="confirma_devolucion()" small color="teal" block dark rounded>Confirma Devolución</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
             </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_table {
    background-color: beige; 
    height: 25px;
    border: 1px solid lightgray;
}
.scroller {
  height: 18em;
  line-height: 1em;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  /*border: 1px solid lightgray;*/
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Devoluciones',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,

    snack:false,
    color_snack:'',
    mensaje:'',

    rut:'',
    nombre:'',
    responsable:0,
    barra:'',
    codigo:'',
        
    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Marca', align: 'start', sortable: true, value: 'txt_marca' },
      { text: 'Modelo', align: 'start', sortable: true, value: 'modelo' },
      { text: 'Serie', align: 'start', sortable: true, value: 'serie' },
    ],
    products_lista: [],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',
    
    bloqueo:null,
    loading:false,
    numClicks:0,

    d_confirma:false,
    orden_dev:'',
    codigo_dev:'',
    producto_dev:'',
    marca_dev:'',
    modelo_dev:'',
    serie_dev:'',
    fecha_dev:'',
    hora_dev:'',
    fecha:'',
    hora:'',
    minuto:'',

    imgSrc:'',

  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    //this.fecha=this.formatFecha(this.hoy);
    this.bloqueo = await this.myPermiso(4);
    if(parseInt(this.bloqueo)!=0){
        await this.searchMyUser();
        await this.searchProducts();
    }
    this.loading=false;
    this.focusBarra();
  },
  methods:{
    focusBarra(){
        var elemento = document.getElementById("barr");
        elemento.focus();
        this.barra="";
    },
    captureBarra(codBarra){
        console.log('entra');
        if(this.barra.trim()!=''){
            const resultado = this.products_lista.filter(res => res.barra == codBarra);
            if(resultado.length!=0){
                const element = resultado[0];
                this.handleProducts(element);
                this.focusBarra();
            } 
            else {
                this.mensaje='Producto no existe';
                this.color_snack='red';
                this.snack=true;
                this.focusBarra();
            };
        }
    },
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async searchMyUser(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                usuario: this.user
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                const element = datos[0];
                this.responsable = element.ID;
                this.rut = element.rut;
                this.nombre = element.nombre;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async searchProducts(){
        let temp_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                responsable: this.responsable
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/devolution/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                temp_lista = datos;
            }
            this.products_lista = temp_lista
        } catch (error) {
            console.log(error)
        }
    },
    handleProducts(item){
        this.orden_dev=item.orden;
        this.codigo_dev=item.codigo;
        this.producto_dev=item.producto;
        this.marca_dev=item.txt_marca;
        this.modelo_dev=item.modelo;
        this.serie_dev=item.serie;
        this.fecha_dev=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.hora_dev=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 16);
        this.fecha=this.formatFecha(this.fecha_dev);
        this.hora=this.hora_dev.substring(0,2);
        this.minuto=this.hora_dev.substring(3,5);
        this.d_products = false;
        this.d_confirma=true;
    },
    async verify_devolution(item){
        this.orden_dev=item.orden;
        this.codigo_dev=item.codigo;
        this.producto_dev=item.producto;
        this.marca_dev=item.txt_marca;
        this.modelo_dev=item.modelo;
        this.serie_dev=item.serie;
        this.fecha_dev=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.hora_dev=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 16);
        this.fecha=this.formatFecha(this.fecha_dev);
        this.hora=this.hora_dev.substring(0,2);
        this.minuto=this.hora_dev.substring(3,5);
        this.d_confirma=true;
    },
    async confirma_devolucion(){
        this.loading=true;
        await this.save_status();
        await this.searchProducts();
        this.d_confirma=false
        this.loading=false
    },
    async save_status(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                fecha: this.fecha_dev,
                orden : this.orden_dev,
                codigo: this.codigo_dev,
                estado: 2, //Revision
                observa: 'Devolucion directa'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/status/order/job/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.mensaje='Producto enviado a revisión';
                this.color_snack='success';
                this.snack=true;
            }                
        } catch (error) {
            console.log(error)
        }
    },
    formatFecha(fec){
      const dia = fec.substring(8,10);
      const mes = fec.substring(5,7);
      const anio = fec.substring(0,4);
      const hoy = dia + '-' + mes + '-' + anio;
      return hoy;
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },

  }
}
</script>
